<template>
  <div>
    <v-dialog
      v-model="mod_dialog"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title" v-show="procStatus == 'MOD'">{{ $t('component.inventor.edit_inventor') }}</h2>
              <h2 class="modal__title" v-show="procStatus == 'VIEW'">{{ $t('component.inventor.view_inventor') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnClosePopup()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" class="pa-0">
          <ValidationObserver ref="observer">
            <v-form v-model="valid">
              <perfect-scrollbar class="h420" id="inventor_wrapper">
                <div class="modal__content__inner__new">
                  <v-row class="ma-0">
                    <v-col cols="12">
                      <v-row>
                        <v-col>
                          <label class="nec_title"><i>*</i> {{ $t('component.inventor.nationality') }}</label>
                          <div class="input_text_type_basic">
                            <v-select
                              dense
                              outlined
                              class="ft-size12 br_none"
                              :disabled="procStatus == 'VIEW'"
                              :items="$vuetify.rtl ? countryArList:countryEnList"
                              v-model="nationality_code"
                            >
                            </v-select>
                          </div>
                        </v-col>

                        <v-col>
                          <label class="nec_title"><i>*</i> {{ $t('component.inventor.residence') }}</label>
                          <div class="input_text_type_basic">
                            <v-select
                              dense
                              outlined
                              class="ft-size12 br_none"
                              :disabled="procStatus == 'VIEW'"
                              :items="$vuetify.rtl ? countryArList:countryEnList"
                              v-model="residence_country_code"
                            >
                            </v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-row>
                        <v-col class="pt-0">
                          <label class="nec_title"><i>*</i> {{ $t('component.inventor.name') }}</label>
                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.inventor.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="name_en"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="name_ar"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                                <div class="box__title">{{ $t('component.inventor.ar') }}</div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('component.inventor.address') }}</label>
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="box__title">{{ $t('component.inventor.en') }}</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="address_en"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.inventor.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="type_ar ie_inpt login_text_field text-right br_none"
                                :disabled="procStatus == 'VIEW'"
                                v-model="address_ar"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="box__title">{{ $t('component.inventor.ar') }}</div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0">
                      <v-row>
                        <v-col>
                          <label class="nec_title">{{ $t('component.inventor.pobox') }}</label>
                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.applicants.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="pobox_en"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">

                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="pobox_ar"
                                  ></v-text-field>
                                </div>
                                <div class="box__title">{{ $t('component.inventor.ar') }}</div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-row class="">
                        <v-col class="">
                          <h2 class="nec_title"><i v-if="nationality_code === 'EG'">*</i> {{ $t('component.inventor.birthday') }}</h2>
                          <div class="input_text_type_basic">
                            <v-menu
                              ref="menu_date"
                              v-model="menu_date"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.birthday')" :rules="{required: nationality_code === 'EG'}">
                                <v-text-field
                                  outlined
                                  solo
                                  dense
                                  flat
                                  hint="DD/MM/YYYY format"
                                  v-bind="attrs"
                                  v-on="on"
                                  append-icon="mdi-calendar"
                                  class="ft-size12 br_none"
                                  :disabled="procStatus == 'VIEW'"
                                  v-model="birthday_date"
                                  :error-messages="errors"
                                  @click:append="menu_date = true"
                                  readonly
                                ></v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker v-model="date" :max="today" no-title @input="menu_date = false"></v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-col class="">
                          <h2 class="nec_title"><i v-if="nationality_code === 'EG'">*</i> {{ $t('component.inventor.gender') }}</h2>
                          <div class="input_checkbox_type_basic radio_dailog_type row ma-0">
                            <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.gender')" :rules="{required: nationality_code === 'EG'}">
                            <v-radio-group
                              row
                              v-model="gender_type_code"
                              :error-messages="errors"
                            >
                              <template v-for="(genderType, i) in $vuetify.rtl ? genderTypeListAr : genderTypeListEn">
                                <v-radio
                                  color="#a01c2a"
                                  :key="genderType.value"
                                  :label="genderType.text"
                                  :value="genderType.value"
                                  :disabled="procStatus == 'VIEW'"
                                >
                                </v-radio>
                                <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                              </template>
                            </v-radio-group>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row>
                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.inventor.telephone') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-phone-in-talk</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="telephone"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.inventor.mobile') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-cellphone-iphone</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="mobile"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.inventor.fax') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-fax</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="fax"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row>
                        <v-col>
                          <label class="nec_title"><i v-if="nationality_code === 'EG'">*</i> {{ $t('component.inventor.email') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title">@</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.email')" :rules="{required: nationality_code === 'EG', email: true }">
                                <v-text-field
                                  outlined
                                  solo
                                  flat
                                  dense
                                  clearable
                                  class="br_none ie_inpt login_text_field text-left email"
                                  :disabled="procStatus == 'VIEW'"
                                  v-model="email"
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="d-flex align-center justify-space-between pop__btn__wrap">
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'VIEW'"
                        @click="fnDeleteApplicantConfirm()"
                      >
                        {{ $t('common.button.delete') }}
                      </v-btn>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'MOD'"
                        @click="fnClosePopup()"
                      >
                        {{ $t('common.button.cancel') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'VIEW'"
                        @click="fnEditMod()"
                      >
                        {{ $t('common.button.edit') }}
                      </v-btn>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'MOD'"
                        @click="fnSave()"
                      >
                        {{ $t('common.button.save') }}
                      </v-btn>
                    </v-col>

                  </v-row>

                </div>
              </perfect-scrollbar>

            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>

    </v-dialog>

    <v-dialog v-model="confirm_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('common.message.delete.confirm.title') }}</v-card-title>
        <v-card-text>{{ $t('common.message.delete.confirm.text') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="sb_btn btn-actv" @click="fnDeleteInventor()">{{ $t('common.button.yes') }}</v-btn>
          <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  props: {
    seq : Number,
    receipt_no : String
  },
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      today: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10),
      menu_date: false,
      menu2: false,
      mod_dialog: true,
      confirm_dialog : false,
      procStatus : 'MOD',
      valid: false,

      countryArList: [],
      countryEnList: [],
      genderTypeListAr: [],
      genderTypeListEn: [],

      nationality_code : '',
      residence_country_code : '',
      name_ar : '',
      name_en : '',
      address_ar : '',
      address_en : '',
      pobox_ar : '',
      pobox_en : '',
      birthday_date: this.formatDate(new Date().toISOString().substr(0, 10)),
      gender_type_code : '',
      telephone : '',
      mobile : '',
      fax : '',
      email : ''

    }
  },
  beforeCreate(){
    //국가목록
    utils.fnGetCountryList('en').then(list => {
      this.countryEnList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    utils.fnGetCountryList('ar').then(list => {
      this.countryArList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    //성별목록
    let options = {
      upper_code: '4000'
    }
    utils.fnGetCodeList(options).then(list => {
      let item = {
        text: 'N/A',
        value: '4003'
      }

      list.ar.push(item)
      list.en.push(item)

      this.genderTypeListAr = list.ar
      this.genderTypeListEn = list.en
    })
  },
  mounted(){
    this.fnGetInventor()
  },
  watch: {
    date () { this.birthday_date = this.formatDate(this.date)},
  },
  methods: {
    fnGetInventor(){
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/inventors/'+this.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.nationality_code = res.data.nationality_code
            this.residence_country_code = res.data.residence_country_code
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.pobox_ar = res.data.pobox_ar
            this.pobox_en = res.data.pobox_en
            this.birthday_date = res.data.birthday_date
            this.gender_type_code = res.data.gender_type_code
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.email = res.data.email

            if (!this.gender_type_code) {
              this.gender_type_code = '4003'
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventor()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      let targetObj = document.querySelector('#inventor_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnClosePopup(){
      this.$emit('success')
    },
    fnEditMod(){
      let targetObj = document.querySelector('#inventor_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          let params = {
            nationality_code : this.nationality_code,
            residence_country_code : this.residence_country_code,
            name_ar : this.name_ar,
            name_en : this.name_en,
            address_ar : this.address_ar,
            address_en : this.address_en,
            pobox_ar : this.pobox_ar,
            pobox_en : this.pobox_en,
            birthday_date : this.birthday_date,
            gender_type_code : (this.gender_type_code === '4003') ? '' : this.gender_type_code,
            telephone : this.telephone,
            mobile : this.mobile,
            fax : this.fax,
            email : this.email
          }

          requestApi({
            url: '/receivings/amendment/'+this.receipt_no+'/inventors/'+this.seq,
            method: 'PUT',
            data: params,
            callback: (res) => {
              if(res.res_code === '200'){
                let option = {
                  text : this.$t('common.message.modify.success'),
                }
                eventBus.$emit('SHOW_SNACKBAR', option)
                this.$emit('success')
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSave()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnDeleteInventorConfirm(){
      this.confirm_dialog = true
    },
    fnDeleteInventor(){
      let message = this.$t('common.message.delete.success')
      requestApi({
        url: '/receivings/amendment/'+this.receipt_no+'/inventors/'+this.seq,
        method: 'DELETE',
        callback: (res) => {
          if(res.res_code === '200'){
            let option = {
              text : message
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            //this.$emit('success')
            this.fnClosePopup()
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteInventor()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      //this.fnClosePopup()
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return ''
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
}

</script>